import { render } from "./TransactionHistoryDetailPanel.vue?vue&type=template&id=3d738d1a&scoped=true&ts=true"
import script from "./TransactionHistoryDetailPanel.vue?vue&type=script&lang=ts"
export * from "./TransactionHistoryDetailPanel.vue?vue&type=script&lang=ts"

import "./TransactionHistoryDetailPanel.vue?vue&type=style&index=0&id=3d738d1a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d738d1a"]])

export default __exports__